var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { IsEnum, IsOptional, IsString } from "class-validator";
import { BaseUserDto, UserType } from "./user.dtos";
export class HealthcareOrganizationUserDto extends BaseUserDto {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], HealthcareOrganizationUserDto.prototype, "type", void 0);
export class HealthcareOrganizationUserForAuthenticationDto extends HealthcareOrganizationUserDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], HealthcareOrganizationUserForAuthenticationDto.prototype, "hashedPassword", void 0);
export class InviteHealthcareOrganizationUserInput extends PickType(HealthcareOrganizationUserDto, [
    "type",
    "email",
    "permissions",
    "onChainUser",
]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class CreateHealthcareOrganizationUserInput extends OmitType(HealthcareOrganizationUserDto, [
    "id",
    "organizationId",
    "onChainUser",
    "passwordExpiresAt",
    "passwordUpdatedAt",
    "loginFailureCount",
    "statusUntil",
    "accountStatus",
]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class UpdateHealthcareOrganizationUserInput extends PartialType(CreateHealthcareOrganizationUserInput) {
    constructor(fields) {
        super();
        this.type = UserType.HEALTHCARE_ORGANIZATION;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], UpdateHealthcareOrganizationUserInput.prototype, "type", void 0);
